import { setlist } from '@/utils/typesense';
import { getComprehensiveListings } from '@/api/comprehensivelistings';
import { MusicPage } from '@/components/_pages/MusicPage';
import { getMusicPageData } from '@/components/_pages/MusicPage/util';
import { HOUR_INTERVAL } from '@/constants/revalidationInterval';
import type { HomePageProps } from '@/components/_pages/MusicPage/types';
import { parseCarousels } from '@/hooks/useTypesenseCarousels/parse-carousels';
import type { GetStaticProps, NextPage } from 'next';
const MusicHomePage: NextPage<HomePageProps> = (props: HomePageProps) => <MusicPage {...props} data-sentry-element="MusicPage" data-sentry-component="MusicHomePage" data-sentry-source-file="index.page.tsx" />;
export const getStaticProps: GetStaticProps<HomePageProps | object> = async () => {
  const [personalisedCarousels, carouselsResponse, comprehensiveListings] = await Promise.all([getMusicPageData(), setlist.getCarousels({
    searchParameters: {
      q: 'music',
      filter_by: 'page_slug:=music'
    }
  }), getComprehensiveListings('music')]);
  const typesenseCarousels = parseCarousels(carouselsResponse);
  return {
    revalidate: HOUR_INTERVAL,
    props: {
      personalisedCarousels,
      typesenseCarousels,
      comprehensiveListings
    }
  };
};
export default MusicHomePage;